import { FAQItem } from '../data/faq';

/**
 * Generate FAQ structured data (schema.org FAQPage)
 * for SEO and rich snippets in search results
 */
export function generateFAQStructuredData(faqItems: FAQItem[]): string {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map(item => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return JSON.stringify(faqSchema);
}

/**
 * Inject FAQ structured data into the document head
 */
export function injectFAQStructuredData(faqItems: FAQItem[]): void {
  // Remove existing FAQ script if any
  const existingScript = document.querySelector('script[data-schema-type="faq"]');
  if (existingScript) {
    existingScript.remove();
  }

  // Create and inject new FAQ schema
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute('data-schema-type', 'faq');
  script.textContent = generateFAQStructuredData(faqItems);
  document.head.appendChild(script);
}
